import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f8fba0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "col",
  id: "operator_cover_pic"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { id: "machine_info_con" }
const _hoisted_4 = { class: "machine_name bold" }
const _hoisted_5 = { class: "rating_line" }
const _hoisted_6 = { class: "rating_tag" }
const _hoisted_7 = { class: "rating_tag" }

import RatingStars from './RatingStars.vue';
    import Row from '../common/RowSection.vue';
    import { PropType } from 'vue';
    import { MachineInfo } from '@/models/landingPage';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MachineInfo',
  props: {
        machine: { type: Object as PropType<MachineInfo>, required: true },
    },
  setup(__props) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Row, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: __props.machine.machinePic
          }, null, 8, _hoisted_2)
        ])
      ]),
      _: 1
    }),
    _createVNode(Row, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(__props.machine.machineId) + " " + _toDisplayString(__props.machine.machineName ? '-' : '') + " " + _toDisplayString(__props.machine.machineName), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(RatingStars, {
              rating: __props.machine.rating ?? 0
            }, null, 8, ["rating"]),
            _createElementVNode("h5", _hoisted_6, _toDisplayString(__props.machine.rating), 1),
            _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.$t('Ratings')), 1)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})